// extracted by mini-css-extract-plugin
export default {"root__type_typing":"A5JlJlsf","root__type_unavailable":"gUXXaJHH"};